import { RouteStore as FluxibleRouteStore } from 'fluxible-router';
import { BaseStore } from 'fluxible/addons';
// import routes from '../config/routes';

class RouteStore extends FluxibleRouteStore {
  constructor(dispatcher) {
    super(dispatcher);
    this._previousRoute = null;
    this._routes = dispatcher.getContext().getRoutes();
  }

  _handleNavigateStart(navigate) {
    this._previousRoute = this._currentRoute;

    super._handleNavigateStart(navigate);
  }

  _matchRoute (url, options) {
    let newRoute = super._matchRoute(url, options);
    // Extract implicit/formatted filters/sorter from category routes
    if(newRoute) {
      if(-1 !== ['category', 'sparkling'].indexOf(newRoute.name)) {
        let extractedParams = this.getContext().extractImplicitQueryParamsFromRoute(newRoute.name, newRoute.params);
        newRoute.params = Object.assign(newRoute.params, extractedParams);
        let decodedQueryParams = this.getContext().decodeQueryParams(newRoute.url.replace(/^.*\?/, ''));
        newRoute.query = Object.assign(newRoute.query, decodedQueryParams);
      } else if (-1 !== ['search', 'universalSearch'].indexOf(newRoute.name)) {
        let decodedQueryParams = this.getContext().decodeQueryParams(newRoute.url.replace(/^.*\?/, ''));
        newRoute.query = Object.assign(newRoute.query, decodedQueryParams);
      }
      newRoute.absolute_url = this.getContext().makeAbsoluteURLFromPath(newRoute.url);
    }
    return newRoute;
  }

  getPreviousRoute() {
    return this._previousRoute;
  }

  dehydrate() {
    let state = super.dehydrate();
    state.routes = null;
    return state;
  }

  rehydrate (state) {
    // NOTE: not setting this._routes = state.routes so we don't override those set in constructor
    this._router = null;
    this._currentUrl = state.currentUrl;
    this._currentRoute = this._matchRoute(this._currentUrl, {
        method: state.currentNavigate && state.currentNavigate.method || 'GET'
    });
    this._currentNavigate = state.currentNavigate;
    this._isNavigateComplete = state.isNavigateComplete;
    this._currentNavigateError = state.currentNavigateError;
  }
}

export default RouteStore;



// WEBPACK FOOTER //
// banquet/stores/RouteStore.js